export const mockUser = {
  success: true,
  data: {
    current_page: 1,
    data: [
      {
        id: 3144,
        fname: "Super",
        lname: "Admin",
        email: "zai@stmpz.co",
        username: "zai1000000",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 1,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "20",
        created_at: "2022-06-21T13:46:10.000000Z",
        referrer: null
      },
      {
        id: 872,
        fname: "Naziha",
        lname: "Mohamad Saad",
        email: "naziha+v2@stmpz.co",
        username: "nazihamohamad saad872",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "173132663",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "30",
        created_at: "2022-08-27T22:56:32.000000Z",
        referrer: null
      },
      {
        id: 258,
        fname: "win",
        lname: "tatt",
        email: "wintatt@stmpz.co",
        username: "wintatt258",
        email_verified_at: null,
        profile_picture_url: null,
        phone: null,
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 1,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "12",
        created_at: "2023-06-13T03:23:40.000000Z",
        referrer: null
      },
      {
        id: 256,
        fname: "jed",
        lname: "stage",
        email: "jedediah+23@stmpz.co",
        username: "jedstage256",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "5",
        created_at: "2023-06-11T10:48:34.000000Z",
        referrer: null
      },
      {
        id: 210,
        fname: "syahira",
        lname: "stmpz",
        email: "syahira.stmpz+1@gmail.com",
        username: "syahirastmpz210",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "43",
        created_at: "2023-01-25T04:42:35.000000Z",
        referrer: null
      },
      {
        id: 195,
        fname: "test win 123",
        lname: "admin 1",
        email: "wintatttest@hotmail.com",
        username: "test winadmin195",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123123441234",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 1,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "17",
        created_at: "2022-09-19T03:53:38.000000Z",
        referrer: null
      },
      {
        id: 192,
        fname: "sue",
        lname: "may",
        email: "suemay@gmail.com",
        username: "suemay192",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "8",
        created_at: "2022-08-15T17:28:12.000000Z",
        referrer: null
      },
      {
        id: 188,
        fname: "shofie",
        lname: "salsabilla",
        email: "shofie.stmpz@gmail.com",
        username: "shofiesalsabilla188",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "5",
        created_at: "2022-08-08T09:16:39.000000Z",
        referrer: null
      },
      {
        id: 183,
        fname: "sue",
        lname: "yeoh",
        email: "suemay.stmpz1@gmail.com",
        username: "suemay183",
        email_verified_at: "2022-08-04T04:13:55.000000Z",
        profile_picture_url: null,
        phone: "12345678",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "3",
        created_at: "2022-07-20T12:31:31.000000Z",
        referrer: null
      },
      {
        id: 113,
        fname: "jedediah",
        lname: "kong",
        email: "jedediah.stmpz@gmail.com",
        username: "jedediahkong113",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "176834331",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "2",
        created_at: "2022-06-22T13:38:30.000000Z",
        referrer: null
      },
      {
        id: 101,
        fname: "Jonathan",
        lname: "Roberts",
        email: "jonathan.stmpz@gmail.com",
        username: "jonathanroberts101",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "126425429",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "12",
        created_at: "2022-06-22T11:10:42.000000Z",
        referrer: null
      },
      {
        id: 96,
        fname: "Jeshua",
        lname: "Choong",
        email: "jeshua.stmpz@gmail.com",
        username: "jeshuachoong96",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "166155847",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "34",
        created_at: "2022-06-22T10:15:54.000000Z",
        referrer: null
      },
      {
        id: 88,
        fname: "win",
        lname: "tatt",
        email: "wintatt.stmpz@gmail.com",
        username: "wintatt88",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "124040545",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 2,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "89",
        created_at: "2022-06-22T08:42:33.000000Z",
        referrer: null
      },
      {
        id: 44,
        fname: "Super",
        lname: "Admin",
        email: "superadmin1@stmpz.co",
        username: "superadmin44",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 1,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "11",
        created_at: "2022-06-21T13:46:10.000000Z",
        referrer: null
      },
      {
        id: 3,
        fname: "Super",
        lname: "Admin",
        email: "superadmin@stmpz.co",
        username: "superadmin3",
        email_verified_at: null,
        profile_picture_url: null,
        phone: "123456789",
        ic_number: null,
        gender: null,
        birthday: null,
        country_code: "+60",
        role_id: 1,
        country_id: 458,
        state_id: null,
        car_brand_id: null,
        car_model_id: null,
        car_color_id: null,
        car_year: null,
        source: "22",
        created_at: "2022-06-21T13:46:10.000000Z",
        referrer: null
      }
    ],
    first_page_url: "https://friday-staging.stmpz.co/api/users?page=1",
    from: 1,
    last_page: 1,
    last_page_url: "https://friday-staging.stmpz.co/api/users?page=1",
    links: [
      {
        url: null,
        label: "&laquo; Previous",
        active: false
      },
      {
        url: "https://friday-staging.stmpz.co/api/users?page=1",
        label: "1",
        active: true
      },
      {
        url: null,
        label: "Next &raquo;",
        active: false
      }
    ],
    next_page_url: null,
    path: "https://friday-staging.stmpz.co/api/users",
    per_page: 15,
    prev_page_url: null,
    to: 15,
    total: 15
  },
  status: "Retrieval successful."
};

export const mockAdmin = {
  current_page: 1,
  data: [
    {
      id: 3144,
      fname: "Super",
      lname: "Admin",
      email: "zai@stmpz.co",
      username: "zai1000000",
      email_verified_at: null,
      profile_picture_url: null,
      phone: "123456789",
      ic_number: null,
      gender: null,
      birthday: null,
      country_code: "+60",
      role_id: 1,
      country_id: 458,
      state_id: null,
      car_brand_id: null,
      car_model_id: null,
      car_color_id: null,
      car_year: null,
      source: "app",
      created_at: "2022-06-21T13:46:10.000000Z",
      referrer: null
    }
  ],
  first_page_url: "https://friday-staging.stmpz.co/api/users?page=1",
  from: 1,
  last_page: 1,
  last_page_url: "https://friday-staging.stmpz.co/api/users?page=1",
  links: [
    {
      url: null,
      label: "&laquo; Previous",
      active: false
    },
    {
      url: "https://friday-staging.stmpz.co/api/users?page=1",
      label: "1",
      active: true
    },
    {
      url: null,
      label: "Next &raquo;",
      active: false
    }
  ],
  next_page_url: null,
  path: "https://friday-staging.stmpz.co/api/users",
  per_page: 15,
  prev_page_url: null,
  to: 15,
  total: 15
};

export const mockNotification = {
  current_page: 1,
  data: [
    {
      id: 1243,
      country_id: 458,
      title: "You have ranked top 2 this month ",
      subtitle: "Enjoy your 20% discouns reward",
      user_ids: [967],
      options: [],
      read: 0,
      is_sent: 0,
      scheduled_at: null,
      created_at: "2024-06-05T03:48:26.000000Z",
      updated_at: "2024-06-05T03:48:26.000000Z"
    },

    {
      id: 1236,
      country_id: 458,
      title: "Visit McDonald today for $2 nuggets",
      subtitle: "$2 for 5 pieces nuggets",
      user_ids: [315],
      options: null,
      read: 0,
      is_sent: 0,
      scheduled_at: null,
      created_at: "2023-10-16T10:50:10.000000Z",
      updated_at: "2023-10-16T10:50:10.000000Z"
    },
    {
      id: 1226,
      country_id: 458,
      title: "Thanks for supporting us",
      subtitle: "We have reward you a $10 voucher",
      user_ids: [13],
      options: null,
      read: 0,
      is_sent: 0,
      scheduled_at: null,
      created_at: "2023-09-15T09:15:00.000000Z",
      updated_at: "2023-09-15T09:15:00.000000Z"
    }
  ],
  first_page_url: "https://friday-staging.stmpz.co/api/notifications?page=1",
  from: 1,
  last_page: 21,
  last_page_url: "https://friday-staging.stmpz.co/api/notifications?page=21",
  links: [
    {
      url: null,
      label: "&laquo; Previous",
      active: false
    },
    {
      url: "https://friday-staging.stmpz.co/api/notifications?page=1",
      label: "1",
      active: true
    }
  ],
  next_page_url: "https://friday-staging.stmpz.co/api/notifications?page=2",
  path: "https://friday-staging.stmpz.co/api/notifications",
  per_page: 15,
  prev_page_url: null,
  to: 15,
  total: 304
};

export const mockTransactions = {
  current_page: 1,
  data: [
    {
      id: 1,
      country_id: 458,
      transaction_type: "Debit",
      type_id: 1,
      relation_id: 3,
      driver_bank_account_id: "01-066-77049200-00",
      amount: 300,
      transaction_fee: null,
      approved_amount: 340,
      reason: null,
      status_id: 27,
      user_id: 13,
      created_at: "2022-06-23T03:18:46.000000Z",
      updated_at: "2022-07-18T07:00:03.000000Z",
      status: {
        id: 27,
        name: "Transferred",
        desc: null,
        model_id: 6,
        created_at: "2022-01-19T02:03:05.000000Z",
        updated_at: "2022-01-19T02:03:05.000000Z"
      },
      type: {
        id: 1,
        name: "Voucher",
        created_at: "2022-03-03T04:48:53.000000Z",
        updated_at: "2022-03-03T04:48:53.000000Z",
        deleted_at: null
      },
      user: {
        id: 13,
        username: "admin-1"
      }
    },
    {
      id: 2,
      country_id: 458,
      transaction_type: "Bank Transfer",
      type_id: 1,
      relation_id: 4,
      driver_bank_account_id: "01-066-77049200-00",
      amount: 25,
      transaction_fee: null,
      approved_amount: 0,
      reason: null,
      status_id: 25,
      user_id: 13,
      created_at: "2022-06-23T04:08:22.000000Z",
      updated_at: "2022-08-17T11:55:34.000000Z",
      status: {
        id: 25,
        name: "Processing",
        desc: null,
        model_id: 6,
        created_at: "2022-01-19T01:28:30.000000Z",
        updated_at: "2022-01-19T01:28:30.000000Z"
      },
      type: {
        id: 1,
        name: "Dashboard",
        created_at: "2022-03-03T04:48:53.000000Z",
        updated_at: "2022-03-03T04:48:53.000000Z",
        deleted_at: null
      },
      user: {
        id: 13,
        username: "admin"
      }
    },
    {
      id: 3,
      country_id: 458,
      transaction_type: "Voucher",
      type_id: 1,
      relation_id: 5,
      driver_bank_account_id: "01-066-77049200-00",
      amount: 3,
      transaction_fee: null,
      approved_amount: 200,
      reason: null,
      status_id: 27,
      user_id: 13,
      created_at: "2022-06-23T04:09:07.000000Z",
      updated_at: "2022-08-08T09:57:07.000000Z",
      status: {
        id: 27,
        name: "Transferred",
        desc: null,
        model_id: 6,
        created_at: "2022-01-19T02:03:05.000000Z",
        updated_at: "2022-01-19T02:03:05.000000Z"
      },
      type: {
        id: 1,
        name: "Voucher",
        created_at: "2022-03-03T04:48:53.000000Z",
        updated_at: "2022-03-03T04:48:53.000000Z",
        deleted_at: null
      },
      user: {
        id: 13,
        username: "Zoe"
      },
      campaign: []
    }
  ],
  first_page_url: "https://friday-staging.stmpz.co/api/transactions?page=1",
  from: 1,
  last_page: 84,
  last_page_url: "https://friday-staging.stmpz.co/api/transactions?page=84",
  next_page_url: "https://friday-staging.stmpz.co/api/transactions?page=2",
  path: "https://friday-staging.stmpz.co/api/transactions",
  per_page: 15,
  prev_page_url: null,
  to: 15,
  total: 1246
};

export const mockRewards = {
  current_page: 1,
  data: [
    {
      reward: "Free Coffee",
      status: "Active",
      user: "wintatt",
      user_claimed_at: "2024/07/20",
      created_at: "2024/07/10"
    },
    {
      reward: "Free Coffee",
      status: "Active",
      user: "george",
      user_claimed_at: "2024/07/20",
      created_at: "2024/07/10"
    },
    {
      reward: "Free Coffee",
      status: "Active",
      user: "Victor",
      user_claimed_at: "2024/07/20",
      created_at: "2024/07/10"
    },
    {
      reward: "Free Coffee",
      status: "Redeemed",
      user: "Henry",
      user_claimed_at: "2024/07/20",
      created_at: "2024/07/10"
    },
    {
      reward: "Free Coffee",
      status: "Expired",
      user: "Kelly",
      user_claimed_at: "2024/07/20",
      created_at: "2024/07/10"
    }
  ],
  first_page_url: "https://friday-staging.stmpz.co/api/notifications?page=1",
  from: 1,
  last_page: 21,
  last_page_url: "https://friday-staging.stmpz.co/api/notifications?page=21",
  links: [
    {
      url: null,
      label: "&laquo; Previous",
      active: false
    },
    {
      url: "https://friday-staging.stmpz.co/api/notifications?page=1",
      label: "1",
      active: true
    }
  ],
  next_page_url: "https://friday-staging.stmpz.co/api/notifications?page=2",
  path: "https://friday-staging.stmpz.co/api/notifications",
  per_page: 15,
  prev_page_url: null,
  to: 15,
  total: 304
};

export const mockVouchers = {
  current_page: 1,
  data: [
    {
      reward: "99 Coffess for $99",
      price: 99,
      status: "Active",
      current_purchase: 20,
      created_at: "2024/07/10"
    },
    {
      reward: "$20 worth for $30",
      price: 20,
      status: "Active",
      current_purchase: 10,
      created_at: "2024/07/10"
    },
    {
      reward: "Free try new coffess",
      price: 0,
      status: "Active",
      current_purchase: 50,
      created_at: "2024/07/10"
    },
    {
      reward: "$5 Voucher",
      price: 5,
      status: "Expired",
      current_purchase: "20",
      created_at: "2024/07/10"
    },
    {
      reward: "$10 voucher",
      price: 10,
      status: "Expired",
      current_purchase: "20",
      created_at: "2024/07/10"
    }
  ],
  first_page_url: "https://friday-staging.stmpz.co/api/notifications?page=1",
  from: 1,
  last_page: 21,
  last_page_url: "https://friday-staging.stmpz.co/api/notifications?page=21",
  links: [
    {
      url: null,
      label: "&laquo; Previous",
      active: false
    },
    {
      url: "https://friday-staging.stmpz.co/api/notifications?page=1",
      label: "1",
      active: true
    }
  ],
  next_page_url: "https://friday-staging.stmpz.co/api/notifications?page=2",
  path: "https://friday-staging.stmpz.co/api/notifications",
  per_page: 15,
  prev_page_url: null,
  to: 15,
  total: 304
};
